import React from 'react';
import { Navigate } from 'react-router';

const TryAIPage: React.FC = () => <Navigate to="/flymate" replace />;

export default TryAIPage;
